export const DEFAULT_VISIBLE = false
export const DEFAULT_FORM_TYPE = 'login'

export default {
  visible: DEFAULT_VISIBLE,
  formType: DEFAULT_FORM_TYPE,
  submitting: false,
  submitted: false,
  errors: {},
  response: {}
}
